import { render } from "./Idefined.vue?vue&type=template&id=9015d4c4&scoped=true"
import script from "./Idefined.vue?vue&type=script&lang=js"
export * from "./Idefined.vue?vue&type=script&lang=js"

import "./Idefined.vue?vue&type=style&index=0&id=9015d4c4&lang=less&scoped=true"

import exportComponent from "E:\\wwwroot\\abz-shuzi\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9015d4c4"]])

export default __exports__